import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import i18n from '../i18n';
import { getLocale } from '../selectors';

export const Translation = ({ section, label, locale, variables }) => {
  const translated = i18n(section, label, locale, variables);

  /* eslint-disable react/no-danger */
  return (
    <span dangerouslySetInnerHTML={{ __html: translated }} />
  );
  /* eslint-enable react/no-danger */
};

Translation.propTypes = {
  section: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  variables: PropTypes.objectOf(
    PropTypes.oneOfType(
      [
        PropTypes.string,
        PropTypes.number
      ]
    )
  ),
  locale: PropTypes.string
};

const mapStateToProps = state => ({
  locale: getLocale(state)
});

export default connect(mapStateToProps)(Translation);
